import axiosClient from "./axiosClient";

const eventServiceApi = {
  getById: (params, language) => {
    const url = `api/event/${params}/${language}`;
    return axiosClient.get(url, params, language);
  },

  getAll: (body) => {
    const url = `api/event/getall`;
    return axiosClient.post(url, body);
  },

  getEventCalendarLunarByCateId: (data) =>{
    const url = `api/event/getallNeedUpdate`;
    return axiosClient.post(url,data)
  },

  createEvent: (params) => {
    const url = `api/event/create`;
    return axiosClient.post(url, params, {
      useAuthorize: true
  });
  },

  updateEvent: (params, data) => {
    const url = `api/event/${params}`;
    return axiosClient.put(url, data, {
      useAuthorize: true
  });
  },

  // calculateCoord: (data) =>{
  //     const url = `api/calculate`
  //     return axiosClient.post(url,data)
  // },
  updateCalendarLunarEvent: (params, data) => {
    const url = `api/event/updateCalendarLunar/${params}`;
    return axiosClient.put(url, data);
  },

  deleteEventById: (params) => {
    const url = `api/event/${params}`;
    return axiosClient.delete(url, {
      useAuthorize: true
  });
  },
  getallnearest: (data) => {
    const url = `api/event/getallnearest`;
    return axiosClient.post(url, data);
  },
};
export default eventServiceApi;
